class ThreeCollection {
  constructor() {
    this.init();
    this.currentIndex = 0; // Track the current active tab index
  }

  init() {
    // Get all collection buttons and content containers
    this.buttons = document.querySelectorAll('.entc-heading-btn');
    this.collections = document.querySelectorAll('.entc-content-products');
    
    // Add click event listeners to all buttons
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => this.handleButtonClick(e));
      // Store the index on the button element for easier reference
      button.dataset.index = index;
    });

    // Initialize the first tab as active if none are active yet
    if (!document.querySelector('.entc-heading-btn-active')) {
      this.activateTab(0);
    } else {
      // Find the currently active tab
      this.buttons.forEach((btn, index) => {
        if (btn.classList.contains('entc-heading-btn-active')) {
          this.currentIndex = index;
        }
      });
    }

    // Initialize touch events for mobile swipe
    this.initTouchEvents();
  }

  initTouchEvents() {
    // Get the container that holds the collections
    const container = document.querySelector('.entc-content-products').parentElement;
    
    let touchStartX = 0;
    let touchEndX = 0;
    
    // Add touch event listeners
    container.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }
  
  handleSwipe(startX, endX) {
    const minSwipeDistance = 50; // Minimum distance to recognize as a swipe
    const swipeDistance = endX - startX;
    
    if (Math.abs(swipeDistance) < minSwipeDistance) {
      // Not a significant swipe
      return;
    }
    
    if (swipeDistance > 0) {
      // Swiped right - go to previous tab
      this.goToPreviousTab();
    } else {
      // Swiped left - go to next tab
      this.goToNextTab();
    }
  }
  
  goToNextTab() {
    const nextIndex = (this.currentIndex + 1) % this.buttons.length;
    this.activateTab(nextIndex);
  }
  
  goToPreviousTab() {
    const prevIndex = (this.currentIndex - 1 + this.buttons.length) % this.buttons.length;
    this.activateTab(prevIndex);
  }
  
  activateTab(index) {
    // Update the current index
    this.currentIndex = index;
    
    // Get the target collection from the button at this index
    const targetCollection = this.buttons[index].getAttribute('data-collection');
    
    // Remove active class from all buttons and collections
    this.buttons.forEach(btn => btn.classList.remove('entc-heading-btn-active'));
    this.collections.forEach(collection => collection.classList.remove('entc-content-products-active'));
    
    // Add active class to the button and collection at this index
    this.buttons[index].classList.add('entc-heading-btn-active');
    document.querySelector(`.entc-content-products[data-collection="${targetCollection}"]`)?.classList.add('entc-content-products-active');
  }

  handleButtonClick(event) {
    const button = event.currentTarget;
    const index = parseInt(button.dataset.index, 10);
    this.activateTab(index);
  }
}

// Initialize when DOM is loaded
if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    new ThreeCollection();
  });
}

// Make it available globally
window.ThreeCollection = ThreeCollection;